// Map > Resources categories built from venue records, so they stay current
// without copying venues into resource_submissions.
//   Rehearsal (REQ-078): backstage or notes mention rehearsal.
//   Repair (REQ-079): affiliate or notes mention repair (DB Music, Music House Indio).
export const VENUE_DERIVED_RESOURCE_CATEGORIES = [
  {
    id: 'rehearsal',
    label: 'Rehearsal',
    description: 'Rehearsal space',
    matches: (venue) => /rehearsal/i.test(`${venue?.backstage || ''} ${venue?.notes || ''}`),
    // A venue can point its rehearsal entry at its own booking page (Trix, REQ-066).
    linkOf: (venue) => venue?.rehearsalUrl || null,
  },
  {
    id: 'repair',
    label: 'Repair',
    description: 'Repair shop',
    matches: (venue) => /repair/i.test(`${venue?.affiliate || ''} ${venue?.notes || ''}`),
    linkOf: () => null,
  },
];

export function venueDerivedResourceCategories(venue) {
  return VENUE_DERIVED_RESOURCE_CATEGORIES.filter((category) => category.matches(venue));
}

// A venue in both Rehearsal and Repair appears twice with the same `venue:<id>`,
// and they share one selection. When a category's search hides a selected item,
// drop it only if that category holds the id: match on (id, categoryId), not on
// the first item with that id (which may be the other category's copy).
export function keepVisibleSelectedIds(selectedIds, items, visibleIds, categoryId) {
  const visible = visibleIds instanceof Set ? visibleIds : new Set(visibleIds || []);
  const inCategory = new Set(
    (items || []).filter((item) => item?.categoryId === categoryId).map((item) => item.id),
  );
  return (selectedIds || []).filter((id) => !inCategory.has(id) || visible.has(id));
}
